import { render, staticRenderFns } from "./VaSpacingInput.vue?vue&type=template&id=65c858fd&scoped=true&"
import script from "./VaSpacingInput.vue?vue&type=script&lang=js&"
export * from "./VaSpacingInput.vue?vue&type=script&lang=js&"
import style0 from "./VaSpacingInput.vue?vue&type=style&index=0&id=65c858fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c858fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
